import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login/Login';
import Home from './components/Home/Home';
import Register from './components/Login/Register';
import Publish from './components/Publish/Publish';
import PurchaseConfirmation from './components/PurchaseConfirmation/PurchaseConfirmation';
import ViewProduct from './components/ViewProduct/ViewProduct';
import Profile from "./components/Nido/Profile";
import './App.css';
import ProfileEdit from "./components/Nido/ProfileEdit";
import UsuarioList from "./components/Admin/UsuarioList"
import ReviewList from "./components/Admin/ReviewList";
import History from "./components/Nido/History";


function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/publish" element={<Publish />} />
            <Route path="/product/:id" element={<ProtectedRoute><ViewProduct /></ProtectedRoute>} />
            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/profile/edit" element={<ProtectedRoute><ProfileEdit /></ProtectedRoute>} />
            <Route path="/purchase/confirmation" element={<ProtectedRoute><PurchaseConfirmation /></ProtectedRoute>} />
            <Route path="/profile/userView" element={<ProtectedRoute><UsuarioList /></ProtectedRoute>} />
            <Route path="/profile/reviewsView" element={<ProtectedRoute><ReviewList /></ProtectedRoute>} />
            <Route path="/profile/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
